import React, { useState } from "react";

const FranqueadosContext = React.createContext([{}, () => { }]);

const FranqueadosProvider = props => {
  const [state, setState] = useState({
    data: [],
    loading: false
  });
  return (
    <FranqueadosContext.Provider value={[state, setState]}>
      {props.children}
    </FranqueadosContext.Provider>
  );
};

export { FranqueadosContext, FranqueadosProvider };
